// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "go-power-c5fe0.firebaseapp.com",
  "projectId": "go-power-c5fe0",
  "storageBucket": "go-power-c5fe0.firebasestorage.app",
  "messagingSenderId": "874549589209",
  "appId": "1:874549589209:web:000fd5646471f46d78fac8",
  "measurementId": "G-NXCJWQ7SLB",
  "apiKey": "AIzaSyD1wDe13XoV9a_dJ73XfuImFOlKE9Nls3Q"
};
